import { create } from 'zustand';
import { UserRole } from './draft.input';

export interface WhiteListInputState {
  role: UserRole;
  userAllowed: boolean | null;
}

interface WhitelistAction {
  setValue<K extends keyof WhiteListInputState>(
    key: K,
    value: WhiteListInputState[K],
  ): void;
  clear(): void;
}

type whitelistStoreType = WhiteListInputState & WhitelistAction;

export const useAdminInputStore = create<whitelistStoreType>((set) => ({
  userAllowed: null,
  role: 'admin-portal',
  setValue(key, value) {
    set((state) => ({
      [key]: value,
    }));
  },
  clear: () => {
    set((state) => ({ role: null, userStatus: null, userRoleStatus: null }));
  },
}));
